import { useEffect, useState } from "react";
import {
  Box,
  useMediaQuery,
  Card,
  CardContent,
  Theme,
  lighten,
} from "@mui/material";
import { Outlet, useParams } from "react-router-dom";
import { SideNav } from "../components/SideNav";
import { AppHeader } from "../components/AppHeader";
import { useProjectTitle } from "../../hooks/useProjectTitle";

export const HomeLayout = ({ title }: { title: string }) => {
  // const isMdUp = useMediaQuery("(min-width:900px)");
  // const [drawerOpen, setDrawerOpen] = useState(isMdUp);
  // const { projectId } = useParams();
  // const { projectTitle } = useProjectTitle(projectId);

  // useEffect(() => {
  //   setDrawerOpen(isMdUp);
  // }, [isMdUp]);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        backgroundColor: (theme: Theme) =>
          theme.palette.mode === "dark"
            ? lighten(theme.palette.background.default, 0.05)
            : theme.palette.action.hover,
      }}
    >
      {/* <SideNav onClose={() => setDrawerOpen(!drawerOpen)} open={drawerOpen} /> */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1.5,
          height: "100%",
        }}
      >
        <Card
          variant="outlined"
          sx={{
            border: "none",
            height: "100%",
            borderRadius: 1.5,
            boxShadow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <AppHeader
            onMenu={() => {}}
            drawerOpen={false}
            title={title}
            currentProjectTitle={""}
          />

          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              p: 0,
            }}
          >
            <Outlet />
          </Box>
        </Card>
      </Box>
    </Box>
  );
};
